<script>
import {
    modalState, hideModal, showModal
} from '@app/store/modalStore.svelte.js';
import {
    fade
} from 'svelte/transition';
const webFrame = window.webFrame;
import * as m from '@app/paraglide/messages.js';

let zoomLevel = $state(webFrame.getZoomFactor() * 100);

function zoomIn() {
    zoomLevel += 10
    webFrame.setZoomFactor(zoomLevel/100);
}

function zoomOut() {
    zoomLevel -= 10
    webFrame.setZoomFactor(zoomLevel/100);
}

function updateZoomLevel() {
    webFrame.setZoomFactor(zoomLevel/100);
}

</script>

<div transition:fade={{duration: 100}} 
     class="modal {modalState.selected === 'zoom' ? 'show d-block' : ''}" 
     role="dialog" 
     tabindex="-1" 
     id="ZoomModal"
     aria-labelledby="zoomModalTitle"
     aria-modal="true">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="zoomModalTitle">{m.zoom_settings()}</h4>
                <button type="button" 
                        class="btn-close" 
                        aria-label={m.close_dialog()}
                        id="zoomCloseBtn" 
                        onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <form>
                    <div class="input-group" role="group" aria-label={m.zoom_controls()}>
                        <button onclick={zoomIn} 
                                id="zoomInBtn"
                                class="btn btn-outline-dark" 
                                type="button"
                                aria-label={m.zoom_in()}>
                            <i class="bi bi-plus-lg" aria-hidden="true"></i>
                        </button>
                        <button onclick={zoomOut} 
                                id="zoomOutBtn"
                                class="btn btn-outline-dark" 
                                type="button"
                                aria-label={m.zoom_out()}>
                            <i class="bi bi-dash-lg" aria-hidden="true"></i>
                        </button>
                        <input type="number" 
                               id="zoomValue"
                               step="10" 
                               min="50" 
                               max="150" 
                               class="form-control" 
                               aria-label={m.zoom_percentage_value()}
                               placeholder={m.zoom_value()} 
                               bind:value={zoomLevel} 
                               onblur={updateZoomLevel}>
                        <span class="input-group-text" aria-hidden="true">%</span>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>
